"use client";

import { c as _c } from "react/compiler-runtime";
import type { AnalyticsPageType } from "@shopify/hydrogen-react";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { NavigationEventsClient_Localization_Fragment } from "./graphql";
export function NavigationEventsClient(t0) {
  const $ = _c(13);
  const {
    localizationMasked,
    pageType
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    page
  } = useAnalytics() || {};
  let t1;
  if ($[0] !== localizationMasked) {
    t1 = readFragmentShopifyStorefront(NavigationEventsClient_Localization_Fragment, localizationMasked);
    $[0] = localizationMasked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const localization = t1;
  const currency = localization.country.currency.isoCode;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[3] !== currency || $[4] !== page || $[5] !== pageType) {
    t3 = () => {
      if (currency && page) {
        page({
          currency,
          pageType
        }).catch(_temp3);
      }
    };
    $[3] = currency;
    $[4] = page;
    $[5] = pageType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== currency || $[8] !== page || $[9] !== pageType || $[10] !== pathname || $[11] !== searchParams) {
    t4 = [currency, page, pageType, pathname, searchParams];
    $[7] = currency;
    $[8] = page;
    $[9] = pageType;
    $[10] = pathname;
    $[11] = searchParams;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  useEffect(t3, t4);
  return null;
}
function _temp3(error) {
  console.error("Error running page", error);
}
function _temp2() {
  window.addEventListener("pageswap", _temp);
}
function _temp(event) {
  console.log("Page swap", event);
}